import { Helmet } from 'react-helmet-async';

function SEO({ 
  title = 'SureLife - Smile to a Worry Free Financial Future',
  description = 'Your trusted partner for a worry-free financial future. Explore our comprehensive financial services, products, and solutions.',
  keywords = 'financial services, insurance, financial planning, SureLife, financial solutions',
  image = '/logo512.png',
  url = window.location.href,
  type = 'website'
}) {
  const fullTitle = title.includes('SureLife') ? title : `${title} | SureLife`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default SEO;
